import api from '../utils/api';

export type ImageStyle = 'photorealistic' | 'infographic' | 'simple';

export interface GenerateRequest {
  topic: string;
  context?: string;
  imageStyle?: ImageStyle;
}

export interface GenerateResponse {
  postText: string;
  imageUrl: string;
  s3Key: string;
  postId: string;
  imageStyle: ImageStyle;
}

export interface RegenerateImageRequest {
  postText: string;
  imageStyle?: ImageStyle;
  postId?: string;
}

export interface RegenerateImageResponse {
  imageUrl: string;
  s3Key: string;
  imageStyle: ImageStyle;
}

export interface LinkedInPost {
  _id: string;
  topic: string;
  context?: string;
  imageStyle: ImageStyle;
  postText: string;
  imageUrl: string;
  status: 'generated' | 'posted';
  postedAt?: string;
  source: 'web' | 'cli';
  createdAt: string;
}

export const generateLinkedInContent = async (request: GenerateRequest): Promise<GenerateResponse> => {
  const response = await api.post('/api/linkedin/generate', request);
  return response.data;
};

export const regenerateLinkedInImage = async (request: RegenerateImageRequest): Promise<RegenerateImageResponse> => {
  const response = await api.post('/api/linkedin/generate-image', request);
  return response.data;
};

export const listLinkedInPosts = async (): Promise<LinkedInPost[]> => {
  const response = await api.get('/api/linkedin/posts');
  return response.data.posts;
};

export const markLinkedInPostPosted = async (id: string): Promise<LinkedInPost> => {
  const response = await api.post(`/api/linkedin/posts/${id}/mark-posted`);
  return response.data.post;
};
